module.exports = __webpack_public_path__ + "static/HSE_Q2-2021_Financial_results_(Investor update)-b1ef4fd513a7b3fac37f937af6db4ef8.pdf";